var React = require('react');

function IconChatMessage (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 64C0 28.7 28.7 0 64 0L448 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-138.7 0L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3l0-80-96 0c-35.3 0-64-28.7-64-64L0 64zm152 80c-13.3 0-24 10.7-24 24s10.7 24 24 24l208 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-208 0zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-112 0z"}));
}

IconChatMessage.defaultProps = {"viewBox":"0 0 512 512","fill":"currentColor"};

module.exports = IconChatMessage;

IconChatMessage.default = IconChatMessage;
